import React, { Component } from 'react'
import Download from 'material-ui/svg-icons/file/cloud-download'
import RaisedButton from 'material-ui/RaisedButton'
import { Card, CardTitle, CardText } from 'material-ui/Card'
import BulkImport from './bulk-import'
import api from '../api'

const fiveMinutes = 300 * 1000

class WebinarExport extends Component<any, any> {
  state = {
    filename: null,
    url: null,
    loading: false
  }

  handleExport = () => {
    this.setState({ loading: true })
    api.get('admin/webinars/export')
      .then(res => res.json())
      .then(res => {
        this.setState({ ...res, loading: false })
        setTimeout(() => this.setState({ filename: null, url: null }), fiveMinutes)
      })
  }

  render () {
    const { filename, url, loading } = this.state

    return (
      <Card style={{ marginBottom: '1em' }}>
        <CardTitle title='Step 1: Export Webinars' />
        <CardText>
          <p>Download all webinars as a CSV containing their IDs, titles, slugs, types, categories, current tags, and start dates. Use this to identify which webinar IDs to include in your tags import.</p>
          <RaisedButton
            label='Export Webinars'
            disabled={loading || filename !== null}
            primary
            icon={<Download />}
            onClick={this.handleExport}
          />
          {url && (
            <a style={{ marginLeft: '1em' }} href={url}>{filename}</a>
          )}
        </CardText>
      </Card>
    )
  }
}

const WebinarTagsImportPage = () => {
  return (
    <div style={{ padding: '1em' }}>
      <WebinarExport />
      <BulkImport
        title='Step 2: Import Webinar Tags'
        uploadPath='admin/webinars/tags_import'
        templatePath='admin/webinars/tags_import/template'
      >
        Bulk-assign tags to webinars by CSV. Each row replaces all existing tags for that webinar.
        <ul>
          <li>Column <strong>Webinar ID</strong>: the numeric webinar ID (use the export above to find IDs)</li>
          <li>Column <strong>Tags</strong>: semicolon-separated tag values (e.g. <code>alumni;grad-student</code>)</li>
          <li>Tags are case-insensitive and stored lowercase</li>
        </ul>
      </BulkImport>
    </div>
  )
}

export default WebinarTagsImportPage
